import { render } from "./ContactForm.vue?vue&type=template&id=55bb335e"
import script from "./ContactForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ContactForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script